import { forwardRef } from 'react';
import { Icon, type IconProps } from './Icon';

type SvgIconProps = Omit<IconProps, 'children'>;

export const ChevronDown = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m6 9 6 6 6-6" />
    </Icon>
  ),
);
ChevronDown.displayName = 'ChevronDown';

export const ChevronRight = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m9 18 6-6-6-6" />
    </Icon>
  ),
);
ChevronRight.displayName = 'ChevronRight';

export const Close = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M18 6 6 18M6 6l12 12" />
  </Icon>
));
Close.displayName = 'Close';

export const Search = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.35-4.35" />
  </Icon>
));
Search.displayName = 'Search';

export const Plus = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M12 5v14M5 12h14" />
  </Icon>
));
Plus.displayName = 'Plus';

export const Minus = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M5 12h14" />
  </Icon>
));
Minus.displayName = 'Minus';

export const Check = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M20 6 9 17l-5-5" />
  </Icon>
));
Check.displayName = 'Check';

export const Warning = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01" />
  </Icon>
));
Warning.displayName = 'Warning';

export const Info = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 16v-4M12 8h.01" />
  </Icon>
));
Info.displayName = 'Info';

export const Edit = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z" />
  </Icon>
));
Edit.displayName = 'Edit';

export const Trash = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
  </Icon>
));
Trash.displayName = 'Trash';

export const Settings = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </Icon>
  ),
);
Settings.displayName = 'Settings';

export const User = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </Icon>
));
User.displayName = 'User';

export const Menu = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon ref={ref} {...props}>
    <path d="M4 12h16M4 6h16M4 18h16" />
  </Icon>
));
Menu.displayName = 'Menu';

export const ArrowLeft = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m12 19-7-7 7-7M19 12H5" />
    </Icon>
  ),
);
ArrowLeft.displayName = 'ArrowLeft';

export const ArrowRight = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <Icon ref={ref} {...props}>
      <path d="m12 5 7 7-7 7M5 12h14" />
    </Icon>
  ),
);
ArrowRight.displayName = 'ArrowRight';

export const Spinner = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
    className={`animate-spin ${props.className ?? ''}`}
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
      fill="none"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      stroke="none"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    />
  </Icon>
));
Spinner.displayName = 'Spinner';
